module.exports = __webpack_public_path__ + "static/media/7.ad41974a.jpg";